export const availableCandidatesStoreKey = 'availableCandidates';
